import htlSettingsQuery from '@/lib/queries/htlSettingsQuery';
import { Box, SxProps } from '@mui/material';
import useGlobalQuery from '@orgnc/core/hooks/useGlobalQuery';
import React from 'react';

export type HashtagLabsAdProps = {
  sx?: SxProps;
  hasBaseHeight?: boolean;
  unit: string;
  size?: string;
};

const HashtagLabsAd: React.FunctionComponent<HashtagLabsAdProps> = (props) => {
  const { sx, unit, size } = props;

  const { data: htlSettings, isLoading } = useGlobalQuery(htlSettingsQuery);
  const site = htlSettings?.acfOptionsGeneral?.generalOptions?.htlAds?.siteId;
  const sizeClass = size ? `/${size}` : '';

  return (
    <Box
      sx={{
        minHeight: props.hasBaseHeight ? { xs: 100, lg: 250 } : undefined,
        ...(sx ?? {}),
      }}
    >
      {isLoading || !site ? null : (
        <div
          className={`opscoad-${unit}`}
          data-unit={`${site}/${unit}${sizeClass}`}
        ></div>
      )}
    </Box>
  );
};

export default HashtagLabsAd;
